export default "__VITE_ASSET__0970238d__"